<section
  class="mt-2 border-t border-borders-light pt-2 dark:border-borders-darker"
>
  <h3 class="!my-2">
    {{
      (book ? "TIME_TRACKING.READING_HISTORY" : "TIME_TRACKING.SESSION_HISTORY")
        | translate
    }}
  </h3>
  <p class="!my-1 text-sm text-grey dark:text-lightGrey">
    {{
      (book ? "TIME_TRACKING.READING_HISTORY_HELP" : "TIME_TRACKING.DAILY_HELP")
        | translate
    }}
  </p>
  @if (history; as value) { @if (value.undatedMinutes) {
  <p class="mb-2 text-sm text-grey dark:text-lightGrey">
    {{
      "TIME_TRACKING.UNDATED_HISTORY"
        | translate: {time: (value.undatedMinutes.toString() | duration)}
    }}
  </p>
  } @for (session of value.sessions; track session.day) {
  <div
    class="border-borders-light py-2 dark:border-borders-darker"
    [class.border-b]="!$last"
  >
    <div
      class="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-x-2 gap-y-1"
      [class]="book ? '' : 'mobile:grid-cols-[minmax(0,1fr)_auto_auto]'"
    >
      <div>
        <time [attr.datetime]="session.day">{{
          session.day | civilDate: "dd/MM/yyyy"
        }}</time
        ><strong class="ml-2">{{
          session.minutes.toString() | duration
        }}</strong>
        @if (book && session.pageFrom !== undefined) {
        <span class="mt-1 block text-sm">{{
          "TIME_TRACKING.READING_PAGES"
            | translate: {from: session.pageFrom, to: session.pageTo}
        }}</span>
        } @else if (book) {
        <span class="mt-1 block text-xs text-grey dark:text-lightGrey">{{
          "TIME_TRACKING.READING_PAGES_UNKNOWN" | translate
        }}</span>
        }
      </div>
      @if (value.source === 'manual') {
      <button
        type="button"
        class="btn btn-small btn-transparent !m-0 !w-auto col-start-2 row-start-1 justify-self-end"
        [disabled]="pending || loading"
        (click)="edit(session)"
      >
        {{ "EDIT_LABEL" | translate }}
      </button>
      <button
        type="button"
        class="col-start-1 row-start-2 justify-self-start text-xs text-grey underline underline-offset-4 dark:text-lightGrey disabled:opacity-50"
        [class.mobile:col-start-3]="!book"
        [class.mobile:row-start-1]="!book"
        [disabled]="pending || loading"
        (click)="remove(session)"
      >
        {{ "TIME_TRACKING.DELETE_SESSION" | translate }}
      </button>
      }
    </div>
    @if (session.estimatedDate && !book) {
    <p class="mt-1 text-xs text-grey dark:text-lightGrey">
      {{ "TIME_TRACKING.ESTIMATED_DATES" | translate }}
    </p>
    } @if (session.completionMinutes) {
    <p class="mt-1 text-xs text-grey dark:text-lightGrey">
      {{
        "TIME_TRACKING.COMPLETION_SUPPLEMENT"
          | translate: {time: (session.completionMinutes.toString() | duration)}
      }}
    </p>
    } @if (editing?.day === session.day) {
    <form
      class="mt-2 space-y-2"
      (ngSubmit)="deleting ? save() : saveRequested.emit()"
    >
      @if (deleting) {
      <p class="!my-1 text-sm">
        {{
          (book
            ? "TIME_TRACKING.DELETE_READING_HELP"
            : "TIME_TRACKING.DELETE_SESSION_HELP"
          ) | translate
        }}
      </p>
      } @else {
      <mat-form-field class="w-full">
        <mat-label>{{ "TIME_TRACKING.SESSION_DATE" | translate }}</mat-label>
        <input
          matInput
          [matDatepicker]="sessionDatePicker"
          [max]="maxDate"
          name="sessionDate"
          [(ngModel)]="sessionDate"
          (dateChange)="changed()"
          [disabled]="pending"
          required
        />
        <mat-datepicker-toggle matSuffix [for]="sessionDatePicker" />
        <mat-datepicker #sessionDatePicker />
        <mat-error>{{
          "TIME_TRACKING.INVALID_SESSION_DATE" | translate
        }}</mat-error>
      </mat-form-field>
      <p class="!my-1 text-sm text-grey dark:text-lightGrey">
        {{ "TIME_TRACKING.SESSION_DATE_HELP" | translate }}
      </p>
      <p class="!my-1 text-sm text-grey dark:text-lightGrey">
        {{
          (book
            ? "TIME_TRACKING.EDIT_READING_HELP"
            : "TIME_TRACKING.EDIT_DAILY_HELP"
          ) | translate
        }}
      </p>
      @if (editingPages) {
      <label
        class="block !mt-1 !mb-1 text-sm"
        [for]="'reading-pages-' + session.day"
        >{{ "TIME_TRACKING.READING_SESSION_PAGES" | translate }}</label
      >
      <input
        type="number"
        inputmode="numeric"
        min="1"
        [id]="'reading-pages-' + session.day"
        name="pages"
        #pagesInput="ngModel"
        required
        [(ngModel)]="pages"
        (ngModelChange)="changed()"
        [disabled]="pending"
        class="block h-[50px] w-full !mb-1 rounded-lg border border-borders-light bg-white px-2 text-[16px] mobile:text-base text-black dark:border-borders-darker dark:bg-blacker dark:text-white"
        [attr.aria-describedby]="'session-error-' + session.day"
      />
      @if (pagesInput.touched && (pagesInput.invalid || error ===
      'TIME_TRACKING.INVALID_BOOK_INPUT')) {
      <p
        [id]="'session-error-' + session.day"
        class="!my-1 text-sm text-form-error dark:text-form-errorLight"
      >
        {{ "TIME_TRACKING.INVALID_BOOK_INPUT" | translate }}
      </p>
      }
      <p class="!my-1 text-sm text-grey dark:text-lightGrey">
        {{
          "TIME_TRACKING.READING_ESTIMATE"
            | translate: {time: (readingMinutes.toString() | duration)}
        }}
      </p>
      } @else {
      <app-game-session-duration
        class="block"
        [(minutes)]="minutes"
        [maximum]="1440"
        [label]="
          book
            ? 'TIME_TRACKING.READING_SESSION_DURATION'
            : 'TIME_TRACKING.DAILY_DURATION'
        "
        [disabled]="pending"
        (changed)="changed()"
      ></app-game-session-duration>
      <div
        class="border-l-2 border-primary bg-black/5 px-2 py-1.5 text-sm dark:bg-white/5"
      >
        {{
          "TIME_TRACKING.DAILY_AFTER"
            | translate: {time: (minutes.toString() | duration)}
        }}
      </div>
      } } @if (editingPages) {
      <div
        class="border-l-2 border-primary bg-black/5 px-2 py-1.5 text-sm dark:bg-white/5"
      >
        {{ "TIME_TRACKING.READING_PAGE_AFTER" | translate: {page: pageAfter} }}
        @if (item().progress?.completed && pageAfter < (value.pageCount ?? 0)) {
        <p class="!mb-0 !mt-1">
          {{ "TIME_TRACKING.CORRECT_COMPLETED" | translate }}
        </p>
        } @else if (!item().progress?.completed && pageAfter ===
        value.pageCount) {
        <p class="!mb-0 !mt-1">
          {{ "TIME_TRACKING.BOOK_WILL_FINISH" | translate }}
        </p>
        }
      </div>
      }
      <div class="flex w-full flex-wrap items-center justify-between gap-2">
        <button
          type="button"
          class="btn btn-small btn-transparent"
          [disabled]="pending"
          (click)="cancel()"
        >
          {{ "TIME_TRACKING.CANCEL" | translate }}
        </button>
        @if (deleting) {
        <button
          type="submit"
          class="btn btn-small !mt-0 !ml-auto !mr-0 !w-auto"
          [disabled]="pending || loading"
        >
          {{
            (pending ? "TIME_TRACKING.SAVING" : "TIME_TRACKING.DELETE_SESSION")
              | translate
          }}
        </button>
        } @else {
        <button type="submit" hidden aria-hidden="true" tabindex="-1"></button>
        }
      </div>
    </form>
    }
  </div>
  } @empty {
  <p class="text-sm text-grey dark:text-lightGrey">
    {{ "TIME_TRACKING.NO_SESSIONS" | translate }}
  </p>
  } @if (value.nextCursor) {
  <button
    type="button"
    class="btn btn-small btn-transparent mt-2"
    [disabled]="loading || pending"
    (click)="load(true)"
  >
    {{ "TIME_TRACKING.MORE_SESSIONS" | translate }}
  </button>
  } } @if (loading) {
  <p role="status" class="mt-2 text-sm">
    {{ "TIME_TRACKING.LOADING" | translate }}
  </p>
  } @if (error) {
  <p
    role="alert"
    class="mt-2 text-sm text-form-error dark:text-form-errorLight"
  >
    {{ error | translate }}
  </p>
  }
</section>
